import React from 'react';

const TwitterIcon = () => {
  return (
    <svg
      width='53'
      height='30'
      viewBox='0 0 53 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='53' height='30' rx='15' fill='url(#x_gradient)' />
      <path
        d='M28.5222 13.7749L34.4785 7H33.0671L27.8952 12.8826L23.7644 7H19L25.2466 15.8955L19 23H20.4115L25.8732 16.7878L30.2356 23H35L28.5218 13.7749H28.5222ZM26.5889 15.9738L25.956 15.0881L20.9201 8.03974H23.0882L27.1522 13.728L27.7851 14.6137L33.0677 22.0075H30.8997L26.5889 15.9742V15.9738Z'
        fill='#043C67'
      />
      <defs>
        <linearGradient
          id='x_gradient'
          x1='5.42961e-06'
          y1='30'
          x2='28.2869'
          y2='-15.3983'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E6E6FF' />
          <stop offset='0.5' stopColor='#E5EFFE' />
          <stop offset='1' stopColor='#CCF8FF' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default TwitterIcon;
